import React from 'react';
import { MyBookings } from './my-bookings/overview';
import { IParkingLandingPageData } from '../domain/pages/IParkingLandingPageData';
import { splitParkingWidgetSection } from '../../content-sections/domain/use-cases/splitParkingWidgetSection';
import { PageLayout } from '../../shared/layout/page/PageLayout';
import { UserPageHeader } from '../../shared/components';
import { ParkingSection, Sections } from '../../content-sections/ui';
import { GuestBanner } from '../../home/ui/GuestBanner';
import { RewardOffers } from '../../account/ui/account-offers/ui/RewardOffers';

interface IParkingLandingPageProps extends IParkingLandingPageData {}

export const ParkingLandingPage = ({ page }: IParkingLandingPageProps) => {
	const { parkingWidgetSection, otherSections } = splitParkingWidgetSection(
		page.fields.sections,
	);

	return (
		<PageLayout page={page}>
			<UserPageHeader page={page} />
			{parkingWidgetSection && (
				<ParkingSection section={parkingWidgetSection} />
			)}
			<GuestBanner />
			<RewardOffers hasHeader showNoRewardsAvailableContainer />
			<MyBookings />
			<Sections sections={otherSections} />
		</PageLayout>
	);
};
